/* ══ Chile Exótico — tema Shopify · interacciones y carro nativo ══ */
(function(){
  'use strict';
  var CX = window.CX || { moneyFormat: '${{amount_no_decimals}}', routes: {} };

  /* ── Formato de dinero (Shopify estándar) ── */
  function formatMoney(cents){
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = CX.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal){
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    var value = '';
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 0);
    }
    return format.replace(placeholder, value);
  }

  var $ = function(s, c){ return (c || document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ── Carro ── */
  var drawer = $('#drawer'), overlay = $('#overlay');
  function openCart(){ document.body.classList.add('cart-open'); refreshCart(); }
  function closeCart(){ document.body.classList.remove('cart-open'); }

  function getCart(){ return fetch(CX.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); }

  function renderCart(cart){
    $$('.cart-count').forEach(function(el){ el.textContent = cart.item_count; });
    var box = $('#drawerItems');
    if (box){
      if (!cart.items.length){
        box.innerHTML = '<div class="drawer-empty">Tu carro está vacío.<br>Descubre nuestras carnes exóticas.</div>';
      } else {
        box.innerHTML = cart.items.map(function(it){
          var img = it.image ? '<img src="' + it.image + '" alt="' + it.title + '">' : '';
          return '<div class="d-item">' +
            '<a href="' + it.url + '">' + img + '</a>' +
            '<div><h5><a href="' + it.url + '">' + it.product_title + '</a></h5>' +
              '<div class="qty">' +
                '<button data-key="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button data-key="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
              '</div></div>' +
            '<div class="p">' + formatMoney(it.final_line_price) + '</div>' +
          '</div>';
        }).join('');
      }
    }
    var promoRow = $('#drawerPromo');
    if (promoRow) promoRow.remove();
    if (cart.total_discount > 0){
      var foot = $('.drawer-foot');
      var row = document.createElement('div');
      row.id = 'drawerPromo'; row.className = 'drawer-promo';
      row.innerHTML = '<span>Descuento <small>aplicado</small></span><span>−' + formatMoney(cart.total_discount) + '</span>';
      foot.insertBefore(row, $('.drawer-total'));
    }
    var totalEl = $('#drawerTotal');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    updatePromo(cart.item_count);
  }

  function refreshCart(){ return getCart().then(renderCart); }

  function addToCart(variantId, qty){
    return fetch(CX.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function(r){ return r.json(); }).then(function(){ return refreshCart(); }).then(function(){ openCart(); });
  }

  function changeLine(key, qty){
    return fetch(CX.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  if ($('#cartOpen')) $('#cartOpen').addEventListener('click', openCart);
  if ($('#drawerClose')) $('#drawerClose').addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('click', function(e){
    var q = e.target.closest('#drawerItems [data-key]');
    if (q){ changeLine(q.dataset.key, Math.max(0, +q.dataset.q)); return; }

    /* Botón "Agregar al carro" en tarjetas */
    var add = e.target.closest('.card .add');
    if (add && add.dataset.variantId){
      e.preventDefault();
      var original = add.textContent;
      add.textContent = 'Agregando…';
      addToCart(add.dataset.variantId, 1).then(function(){
        add.textContent = 'Agregado ✓'; add.classList.add('added');
        setTimeout(function(){ add.textContent = original; add.classList.remove('added'); }, 1200);
      });
      return;
    }

    /* Toda la tarjeta lleva al detalle, salvo botón/enlaces */
    if (!add && !e.target.closest('a') && !e.target.closest('button')){
      var card = e.target.closest('.card[data-href]');
      if (card) location.href = card.dataset.href;
    }
  });

  /* ── Formulario de producto → agregar por AJAX y abrir drawer ── */
  var pform = $('#ProductForm');
  if (pform){
    pform.addEventListener('submit', function(e){
      e.preventDefault();
      var id = (pform.querySelector('[name=id]') || {}).value;
      var qty = +((pform.querySelector('[name=quantity]') || {}).value || 1);
      if (!id) return;
      var btn = pform.querySelector('button[name=add]');
      if (btn){ btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = 'Agregando…'; }
      addToCart(id, qty).then(function(){ if (btn){ btn.disabled = false; btn.textContent = btn.dataset.t; } });
    });
  }

  /* ── Banner de promo (progreso a 5 productos) ── */
  function updatePromo(count){
    var status = $('#promoStatus');
    if (!status) return;
    var dots = $$('#promoDots span');
    var filled = Math.min(count, 5);
    dots.forEach(function(d, i){ d.classList.toggle('filled', i < filled); });
    var remaining = Math.max(0, 5 - count);
    status.textContent = remaining
      ? 'Agrega ' + remaining + ' producto' + (remaining === 1 ? '' : 's') + ' más para activar el descuento.'
      : 'Promo activa: descuento aplicado automáticamente en tu carro.';
  }

  /* ── Popup promocional (una vez por sesión) ── */
  (function(){
    var pop = $('#promoPop'); if (!pop) return;
    if (sessionStorage.getItem('cx-promo-seen')) return;
    var ov = $('#promoOverlay');
    function open(){ document.body.classList.add('promo-open'); }
    function close(){ document.body.classList.remove('promo-open'); sessionStorage.setItem('cx-promo-seen', '1'); }
    var c1 = $('#promoClose'), c2 = $('#promoDismiss'), cta = $('.promo-cta');
    if (c1) c1.addEventListener('click', close);
    if (c2) c2.addEventListener('click', close);
    if (cta) cta.addEventListener('click', close);
    if (ov) ov.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && document.body.classList.contains('promo-open')) close(); });
    setTimeout(open, 1400);
  })();

  /* ── Página de producto: stepper, galería, variantes ── */
  (function(){
    var out = $('#qty'), input = $('#qtyInput');
    if (out && input){
      var qty = 1;
      function set(q){ qty = Math.max(1, q); out.textContent = qty; input.value = qty; }
      if ($('#qMinus')) $('#qMinus').addEventListener('click', function(){ set(qty - 1); });
      if ($('#qPlus')) $('#qPlus').addEventListener('click', function(){ set(qty + 1); });
    }
    var main = $('#pdMainImg');
    $$('.pd-thumbs img').forEach(function(t){
      t.addEventListener('click', function(){
        if (main && t.dataset.full) main.src = t.dataset.full;
        $$('.pd-thumbs img').forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
    var sel = $('#VariantSelect'), price = $('#pdPrice');
    if (sel && price){
      sel.addEventListener('change', function(){
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
      });
    }
  })();

  /* ── Carrusel de relacionados ── */
  (function(){
    var track = $('#relatedGrid'), prev = $('#carPrev'), next = $('#carNext');
    if (!track || !prev || !next) return;
    function step(){
      var card = track.querySelector('.card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var per = Math.max(1, Math.floor(track.clientWidth / (card.offsetWidth + gap)));
      return per * (card.offsetWidth + gap);
    }
    function sync(){
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    requestAnimationFrame(sync);
  })();

  /* ── Filtros de colección: auto-enviar al cambiar ── */
  (function(){
    var form = $('#FacetForm');
    if (form){
      form.addEventListener('change', function(){ form.submit(); });
      $$('#FacetForm .chip').forEach(function(label){
        label.addEventListener('click', function(){ setTimeout(function(){ form.submit(); }, 0); });
      });
    }
    /* Botón "Filtros" en móvil */
    var toggle = $('#filtersToggle'), side = $('#filters');
    if (toggle && side){
      toggle.addEventListener('click', function(){
        var open = side.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  })();

  /* ── Reveal al hacer scroll ── */
  (function(){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.reveal:not(.visible)').forEach(function(el){ io.observe(el); });
  })();

  /* ── Menú móvil ── */
  (function(){
    var burger = $('#burger'), nav = $('#nav');
    if (burger && nav){
      burger.addEventListener('click', function(){ nav.classList.toggle('open'); });
      $$('#nav .link').forEach(function(a){ a.addEventListener('click', function(){ nav.classList.remove('open'); }); });
    }
    var header = $('#header');
    if (header) window.addEventListener('scroll', function(){ header.classList.toggle('scrolled', window.scrollY > 10); });
  })();

  /* ── Video hero (boomerang) ── */
  (function(){
    var f = $('#heroVideo'), r = $('#heroVideoReverse');
    if (!f) return;
    if (r){
      f.addEventListener('ended', function(){ f.classList.remove('is-active'); r.classList.add('is-active'); r.currentTime = 0; r.play(); });
      r.addEventListener('ended', function(){ r.classList.remove('is-active'); f.classList.add('is-active'); f.currentTime = 0; f.play(); });
    }
    f.play && f.play().catch(function(){});
  })();

  /* Estado inicial del carro/promo */
  getCart().then(function(cart){ updatePromo(cart.item_count); }).catch(function(){});
})();
